import { isDesktopLayout } from "../../common/hooks/useIsDesktopView";
import { NotificationPrompt } from "./components/NotificationPrompt";
import { useTrackOnMount } from "../../hooks/use-track-on-mount";
import { useFixupReturnTo } from "./useFixupReturnTo";
import {
  gaEventPushOptInAnswered,
  gaEventPushOptInShown,
} from "../../tools/analytics/domains/onboarding.analytics";

export default function NotificationFixupPage() {
  const returnToRequestedPage = useFixupReturnTo();

  useTrackOnMount(
    "push-opt-in-shown",
    { status: "shown", key: "notification_fixup" },
    () => {
      gaEventPushOptInShown({ surface: "notification_fixup" });
    }
  );

  const prompt = (
    <NotificationPrompt
      onDone={(outcome) => {
        gaEventPushOptInAnswered({ surface: "notification_fixup", outcome });
        returnToRequestedPage();
      }}
    />
  );

  // Desktop: the same prompt in a centered card instead of the full-screen
  // phone layout.
  if (isDesktopLayout()) {
    return (
      <div className="flex h-dvh w-full items-center justify-center bg-ds-slate-50 p-8">
        <div className="flex w-full max-w-md flex-col rounded-2xl border border-ds-black/8 bg-white px-6 py-8 shadow-sm">
          {prompt}
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col h-dvh w-full bg-white px-6 pb-8"
      style={{ paddingTop: "calc(4rem + var(--safe-area-top))" }}
    >
      {prompt}
    </div>
  );
}
